import { CHCHeadingListItem } from "./heading-list-item.component.js";
customElements.define("chc-heading-list-item", CHCHeadingListItem);
export {
  CHCHeadingListItem
};
//# sourceMappingURL=heading-list-item.js.map
